var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-time-wrapper" },
    [
      _c("style", {
        tag: "component",
        domProps: { innerHTML: _vm._s(_vm.useCss ? _vm.useCssValue : false) }
      }),
      _vm._v(" "),
      _vm.$ceres.isShopBuilder ||
      (_vm.checkAvailibilityID.includes(
        _vm.currentVariation.variation.availability.id
      ) &&
        _vm.feiertage.length > 1)
        ? _c(
            "div",
            {
              staticClass: "delivery-time-container",
              class: "av_" + _vm.currentVariation.variation.availability.id
            },
            [
              !_vm.$ceres.isShopBuilder
                ? _c(
                    "div",
                    {
                      class: "bg-" + _vm.appearance,
                      style: _vm.roundedCorners
                        ? { borderRadius: _vm.roundedCornersValue + "px" }
                        : {}
                    },
                    [
                      _vm.countdown > 0 &&
                      !_vm.sunday &&
                      !_vm.holiday &&
                      _vm.currentDay != 6
                        ? [
                            _c("div", {
                              class: this.$attrs.spacingclasses,
                              style:
                                this.$attrs.inlinepadding +
                                this.$attrs.inlinemargin,
                              domProps: { innerHTML: _vm._s(_vm.updatedHTML) }
                            })
                          ]
                        : _vm.countdown > 0 &&
                          !_vm.sunday &&
                          !_vm.holiday &&
                          _vm.currentDay == 6 &&
                          _vm.saturdayWeekday
                        ? [
                            _c("div", {
                              class: this.$attrs.spacingclasses,
                              style:
                                this.$attrs.inlinepadding +
                                this.$attrs.inlinemargin,
                              domProps: { innerHTML: _vm._s(_vm.updatedHTML) }
                            })
                          ]
                        : (_vm.countdown <= 0 ||
                            _vm.sunday ||
                            _vm.holiday ||
                            (_vm.currentDay == 6 && !_vm.saturdayWeekday)) &&
                          _vm.showShippingTimeHtmlNoShippingToday
                        ? [
                            _c("div", {
                              class: this.$attrs.spacingclasses,
                              style:
                                this.$attrs.inlinepadding +
                                this.$attrs.inlinemargin,
                              domProps: { innerHTML: _vm._s(_vm.updatedHTMLNo) }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$ceres.isShopBuilder && _vm.showShopBuilderInfo
                ? _c(
                    "code",
                    {
                      staticStyle: {
                        "font-size": "75%!important",
                        "padding-bottom": "10px",
                        display: "block"
                      }
                    },
                    [
                      _vm._v("Vorschau!"),
                      _vm.countdown < 0
                        ? [_vm._v(" Negativer Countdown nur im Shopbuilder!")]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$ceres.isShopBuilder
                ? _c(
                    "div",
                    {
                      class: "bg-" + _vm.appearance,
                      style: _vm.roundedCorners
                        ? { borderRadius: _vm.roundedCornersValue + "px" }
                        : {}
                    },
                    [
                      isNaN(parseFloat(_vm.countdown))
                        ? _c(
                            "div",
                            {
                              class: this.$attrs.spacingclasses,
                              style:
                                this.$attrs.inlinepadding +
                                this.$attrs.inlinemargin
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "DeliveryTimeWidget::Template.notValid"
                                  )
                                )
                              )
                            ]
                          )
                        : _c("div", {
                            class: this.$attrs.spacingclasses,
                            style:
                              this.$attrs.inlinepadding +
                              this.$attrs.inlinemargin,
                            domProps: { innerHTML: _vm._s(_vm.updatedHTML) }
                          })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$ceres.isShopBuilder &&
              !_vm.showShopBuilderInfo &&
              _vm.showShippingTimeHtmlNoShippingToday
                ? _c("hr")
                : _vm._e(),
              _vm._v(" "),
              _vm.$ceres.isShopBuilder &&
              _vm.showShippingTimeHtmlNoShippingToday &&
              _vm.showShopBuilderInfo
                ? _c(
                    "code",
                    {
                      staticStyle: {
                        "font-size": "75%!important",
                        "padding-bottom": "10px",
                        display: "block",
                        "padding-top": "10px"
                      }
                    },
                    [_vm._v("Vorschau bei Versand am nächstmöglichen Tag:")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$ceres.isShopBuilder &&
              _vm.showShippingTimeHtmlNoShippingToday
                ? _c(
                    "div",
                    {
                      class: "bg-" + _vm.appearance,
                      style: _vm.roundedCorners
                        ? { borderRadius: _vm.roundedCornersValue + "px" }
                        : {}
                    },
                    [
                      isNaN(parseFloat(_vm.countdown))
                        ? _c(
                            "div",
                            {
                              class: this.$attrs.spacingclasses,
                              style:
                                this.$attrs.inlinepadding +
                                this.$attrs.inlinemargin
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "DeliveryTimeWidget::Template.notValid"
                                  )
                                )
                              )
                            ]
                          )
                        : _c("div", {
                            class: this.$attrs.spacingclasses,
                            style:
                              this.$attrs.inlinepadding +
                              this.$attrs.inlinemargin,
                            domProps: { innerHTML: _vm._s(_vm.updatedHTMLNo) }
                          })
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }